import { data } from '../../svg/Trending/data';
import { makeIcon } from '../makeIcon';

export const Trending = makeIcon(data, 'trending', 'Trending');

export default Trending;
